import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { useClientStore } from '../../stores/clientStore';
import { UserAccessInfo } from '../../models/core';

const ClientDetails: React.FC = () => {
	const { client, plans } = useClientStore();

	if (!client) {
		return null;
	}

	return (
		<Paper sx={{ p: 2, borderRadius: 2, minHeight:200 }}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={4}>
					<Typography variant="h6">{client.name}</Typography>
					<Typography variant="body2">Practice ID: {client.practiceId}</Typography>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Typography variant="h6">Plans</Typography>
					{
                        plans?.map((plan) => (
                            <Typography key={plan._id} variant="body2">
                                {plan.name}
                            </Typography>
                        ))
                    }
				</Grid>
				<Grid item xs={12} sm={4}>
					<Typography variant="h6">Representatives</Typography>
					{
                        (client.userAccess && client.userAccess?.length != 0) 
                            ? client.userAccess?.map((user: UserAccessInfo) => (
                                <Typography key={user.id} variant="body2">
                                    {user.name}
                                </Typography>
                            ))
                            : client.userAccess?.map((rep) => (
                                <Typography key={rep.name} variant="body2">
                                    {rep.name}
                                </Typography>
                            ))
                    }
				</Grid>
			</Grid>
		</Paper>
	);
};

export default ClientDetails;